<template>
    <v-dialog
        v-model="showDialog"
        persistent
        max-width="780px"
    >
        <v-card style="height: 100% !important;" flat>
            <v-card-title>
                {{ indicator.group_code }} <br> {{ indicator.indicator_type_code }} - {{indicator.indicator_type_name}}
            </v-card-title>


            <v-data-table
                :headers="headers"
                :items="mapItems(indicator.details)"
                :items-per-page="10"
                multi-sort
                class="table"
                hide-default-footer
            >
                <template #no-data>
                    <span>{{ $t('indicators.indicators_list.no_records_found') }}</span>
                </template>

                <template v-slot:body.append>
                    <tr class="sticky-table-footer">
                        <td v-text="" />
                        <td v-text="" />

                        <td style="font-size: 1rem; font-weight: bold;text-transform: capitalize" v-text="$t('indicators.indicators_editing.total')" />
                        <td style="font-size: 1rem; font-weight: bold" v-text="indicator.total" />

                        <td v-text="" />
                        <td v-text="" />
                    </tr>
                </template>

            </v-data-table>

            <v-card-actions class="justify-center" style="padding: 20px 20px 20px 20px">

                <v-btn
                    class="v-btn--secondary"
                    text
                    @click="closeDialog"
                >{{ $t('app.cancel') }}</v-btn>
            </v-card-actions>


        </v-card>
    </v-dialog>
</template>

<script>

import {IndicatorsStore} from "@/Store/Indicators/IndicatorsStore";
import {mapState, mapActions} from "pinia";
import {i18n} from "@/i18n";
import _ from "lodash";

export default {
    name: "IndicatorDetailsDialog",

    props: {
        showDialog: {
            type: Boolean,
            default: false,
            required: true
        },
        indicator: {
            type: Object,
            required: true
        },
    },

    data() {
        return {
            headers:  [
                { text: i18n.t('indicators.indicators_editing.headers.program'),
                    align: 'start',
                    value: 'program_1'
                },
                { text: i18n.t('indicators.indicators_editing.headers.value'),
                    align: 'start',
                    value: 'value_1'
                },
                { text: i18n.t('indicators.indicators_editing.headers.program'),
                    align: 'start',
                    value: 'program_2'
                },
                { text: i18n.t('indicators.indicators_editing.headers.value'),
                    align: 'start',
                    value: 'value_2'
                },
                { text: i18n.t('indicators.indicators_editing.headers.program'),
                    align: 'start',
                    value: 'program_3'
                },
                { text: i18n.t('indicators.indicators_editing.headers.value'),
                    align: 'start',
                    value: 'value_3'
                },
            ],
        }
    },

    computed: {
        indicatorToTable() {
            return [this.indicator]
        },
        editingIndicator() {
            return this.indicator
        },
        ...mapState(IndicatorsStore, ['indicatorToCustomize']),
    },

    methods: {

        mapItems(object){
            if (typeof(object) != "undefined") {
                let result = [];
                for (const [key, value] of Object.entries(object)) {
                    let entries  = Object.entries(value)
                    let item = [];
                    for (const [key_, value_] of entries) {
                        item[key_] = value_;
                    }
                    result.push(Object.assign({}, item));
                }
                return result;
            }
        },

        /**
         * Closes the deletion dialog
         */
        closeDialog() {
            this.$emit('cancelEditingDialog')
        },

        ...mapActions(IndicatorsStore, [
            'customize', 'setIndicatorToCustomize',
        ])
    },

    watch: {
        'editingIndicator.total': {
            handler() {
                this.setIndicatorToCustomize(this.editingIndicator);
            },
        }
    },
}
</script>

<style lang="scss" scoped>
::v-deep .table {
    td {
        border-right: thin solid rgba(0, 0, 0, .12) !important;
    }
    tr:nth-last-child(2){
        td {
            border-bottom: thin solid rgba(0, 0, 0, .12) !important;
        }
    }

    tr:last-child {
        td {
            border: none !important;
        }
    }
}
</style>
